import React from "react";
import { Link } from "react-router-dom";
import { Settings as SettingsIcon, ArrowRight } from "lucide-react";

// Not a placeholder -- there's a real, full settings/user/role management
// UI already, it's just the generic admin Dashboard shell (/dashboard),
// not something worth rebuilding a parallel copy of here. This page exists
// so the sidebar item lands somewhere useful instead of a dead end.
export default function SettingsLink() {
  return (
    <div>
      <div style={styles.header}>
        <h1 style={styles.title}>Settings</h1>
        <div style={styles.subtitle}>Platform-wide settings live in the admin console.</div>
      </div>
      <Link to="/dashboard" style={styles.card}>
        <div style={styles.icon}>
          <SettingsIcon size={18} />
        </div>
        <div style={{ flex: 1 }}>
          <div style={styles.cardTitle}>Open the Platform Builder</div>
          <div style={styles.cardSubtitle}>Users, roles, ACLs, tables, business rules, and everything else that shapes the platform.</div>
        </div>
        <ArrowRight size={16} color="var(--muted)" />
      </Link>
    </div>
  );
}

const styles = {
  header: { marginBottom: 20 },
  title: { fontSize: 22, fontWeight: 800, color: "var(--ink)", margin: 0 },
  subtitle: { fontSize: 13, color: "var(--muted)", marginTop: 4 },
  card: {
    display: "flex", alignItems: "center", gap: 14, background: "var(--card)", border: "1px solid var(--line)",
    borderRadius: "var(--radius-lg)", padding: "18px 20px", boxShadow: "var(--shadow-xs)",
    textDecoration: "none", maxWidth: 480,
  },
  icon: {
    width: 38, height: 38, borderRadius: 10, background: "rgba(29, 111, 216,0.1)", color: "var(--brand)",
    display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
  },
  cardTitle: { fontSize: 14, fontWeight: 700, color: "var(--ink)" },
  cardSubtitle: { fontSize: 12.5, color: "var(--muted)", marginTop: 3, lineHeight: 1.4 },
};
